<template>
  <div class="wrapper">

    <table style="width: 100%;height: 100%" cellspacing="3" >
      <tr>
        <td @click.stop="click">1</td>
        <td @click.stop="click">2</td>
        <td @click.stop="click">3</td>
        <td @click.stop="click">+</td>
      </tr>
      <tr>
        <td @click.stop="click">4</td>
        <td @click.stop="click">5</td>
        <td @click.stop="click">6</td>
        <td @click.stop="click">-</td>
      </tr>
      <tr>
        <td @click.stop="click">7</td>
        <td @click.stop="click">8</td>
        <td @click.stop="click">9</td>
        <td @click.stop="click" rowspan="2">*</td>
      </tr>
      <tr>
        <td @click.stop="click" colspan="2">0</td>
        <td @click.stop="click">.</td>
      </tr>
      <tr>
        <td @click.stop="click">(</td>
        <td @click.stop="click">)</td>
        <td @click.stop="click" colspan="2">/</td>
      </tr>
    </table>


  </div>
</template>

<script>
  export default {
    name: "Calculator",
    data(){
      return {

      }
    } ,
    methods:{
      click(event){
        this.$emit('clickitem',event.target.innerText)
      }
    }
  }
</script>

<style scoped>
  .wrapper{
    width: 100%;
    height: 100%;
  }
  td{
    background-color: rgba(220,220,220,.4);
    cursor: pointer;
    font-weight: bold;
    /*padding: 10px;*/
  }
  tr{
    margin-bottom: 10px;
  }
  td:active{
    background-color: #CFA868;
  }

</style>
